export default __webpack_public_path__ + "static/media/GothamSSm-Light.9f552ca8.eot";